<template>
  <div class="app-main-content">
    <write-off-search
      ref="writeOffSearch"
      :custom-sim-query-placeholder="simQueryPlaceholder"
      config-module="510"
      grid-config-module="191001"
      :ar="ar"
      :is-bank-slip="isBankSlip"
      :is-real-send-receive="true"
      :arap-group="true"
      :cargo-grid-state-btn="false"
      :show-invoice-detail="true"
      :show-bill-payment-detail="true"
      @queryResultCallBack="queryResultCallBack"
      @clickedCallBack="row => clickRow = row"
    >
      <div slot="operations" style="display: inline">
        <!--新增实收-->
        <el-button no="newActualReceipt" type="primary" @click="newAmountHandler(true)">{{ $t('Payment.newActualReceipt') }}</el-button>
        <!--新增实付-->
        <el-button no="newActualPayment" type="primary" @click="newAmountHandler(false)">{{ $t('Payment.newActualPayment') }}</el-button>
        <!--修改-->
        <el-button no="edit" type="primary" :disabled="clickRow === null" @click="updateAmountHandler">{{ $t('Payment.edit') }}</el-button>
        <!--作废-->
        <el-button no="invalid" type="danger" :disabled="clickRow === null" @click="invalidAmountHandler">{{ $t('Payment.invalid') }}</el-button>
        <!--查看销账明细-->
        <el-button no="viewWriteOffList" type="primary" :disabled="clickRow === null" @click="showWriteoffDetailHandler">{{ $t('Payment.viewWriteOffList') }}</el-button>
        <!--修改核销状态-->
        <el-button
          v-if="$checkPermission(['button_ACActual_modifyWriteoffMatchStatus'])"
          no="modifyMatchStatus"
          type="primary"
          @click="modifyMatchStatusHandler"
        >{{ $t('WriteOff.modifyMatchStatus') }}</el-button>
        <el-dropdown split-button type="primary" class="el-dropdown-spacing" @click="exportHandle()" @command="p=>{exportCommand=p;exportHandle()}">
          <el-upload
            v-if="$t('CargoMsg.Cargo_Import') === exportCommand"
            :action="URL.act.actualAmount.receiptAndPaymentImportUrl"
            :data="{ branchId:$store.getters.currentOfficeId }"
            :headers="{sessionId:$store.getters.userInfo.sessionId}"
            :show-file-list="false"
            accept=".xls,.xlsx"
            :before-upload="beforeUpload"
            :on-success="uploadSuccess"
            :on-error="handleError"
            style="display: inline-block;margin-left: 5px"
          >
            <span style="color: white">{{ exportCommand }}</span>
          </el-upload>
          <span v-if="exportCommand === $t('SeaExport.TemplateDownload')">{{ $t('SeaExport.TemplateDownload') }}</span>
          <el-dropdown-menu slot="dropdown">
            <el-dropdown-item :command="$t('CargoMsg.Cargo_Import')">
              <el-upload
                ref="batchImport"
                :action="URL.act.actualAmount.receiptAndPaymentImportUrl"
                :data="{ branchId:$store.getters.currentOfficeId }"
                :headers="{sessionId:$store.getters.userInfo.sessionId}"
                :show-file-list="false"
                accept=".xls,.xlsx"
                :before-upload="beforeUpload"
                :on-success="uploadSuccess"
                :on-error="handleError"
                style="display: inline-block;margin-left: 5px"
              >
                <el-button slot="trigger" type="text" style="padding-left: 0px;color: #6F6F6F;text-align: left;width: 80px;">{{ $t('CargoMsg.Cargo_Import') }}</el-button>
              </el-upload>
            </el-dropdown-item>
            <el-dropdown-item :command="$t('SeaExport.TemplateDownload')">{{ $t('SeaExport.TemplateDownload') }}</el-dropdown-item>
          </el-dropdown-menu>
        </el-dropdown>
      </div>
    </write-off-search>
    <!-- 新增/编辑 收/付款 弹窗 -->
    <actual-dialog
      v-if="allowEdit"
      :visible.sync="actualDialog.visible"
      :params="actualDialog.params"
      :ar="actualDialog.ar"
      @refresh="refreshData"
    />
    <!-- 销账明细弹窗 -->
    <charge-write-off-detail-dialog
      :visible.sync="chargeWriteOffDetailDialog.visible"
      :actual-amount-uuid="chargeWriteOffDetailDialog.actualAmountUuid"
      :is-ar="chargeWriteOffDetailDialog.isAr"
      :is-bill="chargeWriteOffDetailDialog.isBill"
      :is-setoff="chargeWriteOffDetailDialog.isSetoff"
      :total-group-type="chargeWriteOffDetailDialog.totalGroupType"
    />
    <!-- 修改核销状态弹窗 -->
    <modify-match-status-dialog
      :visible.sync="modifyMatchStatusDialog.visible"
      :selected-rows="modifyMatchStatusDialog.selectedRows"
      @confirmSuccess="refreshData"
    />
  </div>
</template>

<script>
import searchItem from '@/components/Cargo/Common/cargoCombinationSearch'

import { ErrorTip } from '@/utils/class/ErrorTip'
import cargoAdvanceSelect from '@/components/Cargo/Common/cargoAdvanceSelect'
import * as writeoffApi from '@/api/act/writeoff'
import writeOffSearch from '@/views/cargo/v0/Clearing/components/Writeoff/writeOffSearch'
import { TYPE_NAMES } from '@/utils/class/AdvanceSelect'
import * as ClearingConstants from '@/class/cargo/model/parameters/ClearingConstants'
import DateUtils from '@/utils/dateUtils'
import * as actualAmountApi from '@/api/clearing/actualAmount'
import actualDialog from '@/views/cargo/v0/Clearing/components/clRealSendReceive/actualDialog'
import chargeWriteOffDetailDialog from '@/views/cargo/v0/Clearing/components/clRealSendReceive/ChargeWriteOffDetailDialog'
import modifyMatchStatusDialog from '@/views/cargo/v0/Clearing/components/clRealSendReceive/modifyMatchStatusDialog'
import { getLoading } from '@/utils/utilBaseElement'
import lodash from 'lodash'
import * as RateUtil from '@/class/cargo/model/utils/RateUtil'
import URL from '@/api/urlTranslator'
import { ExportUtils } from '@/class/cargo/model/utils/ExportUtils'

export default {
  name: 'ClRealSendReceive',
  components: { searchItem, writeOffSearch, cargoAdvanceSelect, actualDialog, chargeWriteOffDetailDialog, modifyMatchStatusDialog },
  props: {
    allowEdit: {
      type: Boolean,
      default: true
    }
  },
  data() {
    return {
      loading: null,
      showRecordButton: true, // 显示 收/付款记录按钮
      lockRecordButton: false, // 标记收/付款记录按钮lock状态 用于显示按钮文字
      selectTypeNames: TYPE_NAMES,
      clickRow: null, // 列表选中行
      simQueryPlaceholder: this.$t('Clearing.QuickRetrieval') + this.$t('WriteOff.writeOffSerialNumber'),
      ar: -1,
      isPrepay: -1, // 是否预付
      isBankSlip: 0, // 是否水单
      rowData: [],
      actualDialog: {
        ar: -1,
        visible: false,
        isReceive: false,
        initalForm: {},
        params: null
      },
      chargeWriteOffDetailDialog: {
        visible: false,
        actualAmountUuid: '',
        isBill: false,
        isAr: true,
        isSetoff: false,
        totalGroupType: 'ar'
      },
      modifyMatchStatusDialog: {
        visible: false,
        selectedRows: []
      },
      URL,
      exportCommand: this.$t('CargoMsg.Cargo_Import')
    }
  },
  created() {
  },
  errorCaptured(err) {
    if (err instanceof ErrorTip) {
      this.$message(err)
      return false
    }
    return true
  },
  methods: {
    // 新增实收/实付 按钮事件
    newAmountHandler(isReceive) {
      // actualForm.isAr = isReceive
      this.actualDialog.ar = isReceive ? 1 : 0
      const model = {}
      model.ar = isReceive ? 1 : 0
      model.branchId = this.$store.getters.currentOfficeId
      const localCurrency = RateUtil.localCurrencyByOffice()
      model.currency = localCurrency
      model.payReceiveDate = DateUtils.customFormat(new Date(), 'YYYY-MM-DD')
      model.voucherNo = ''
      model.paymentCompany = ''
      model.companyBank = ''
      model.companyBankAccount = ''
      model.preRemark = '' // 预收付备注
      this.actualDialog.isReceive = isReceive
      this.actualDialog.params = model
      this.actualDialog.visible = true
    },
    faultHandler() {
      this.$message.warning(this.$t('CargoMsg.Cargo_SystemBusyPRL'))
    },
    // 刷新列表 回调事件
    refreshData() {
      this.clickRow = null
      if (!this.$refs.writeOffSearch.conditionsAndRequires) {
        const conditionsMap = {}
        conditionsMap.simpleTriggerMode = false
        conditionsMap.conditions = []
        this.$refs.writeOffSearch.queryBtnClickHandler(conditionsMap)
      } else {
        this.$refs.writeOffSearch.query()
      }
    },
    // 修改 按钮事件
    async updateAmountHandler() {
      this.loading = getLoading()
      if (!this.clickRow) {
        this.$message.warning(this.$t('CargoMsg.Cargo_NoDataSelected'))
        this.closeLoading()
        return
      }
      const actualAmount = this.clickRow
      if (actualAmount.state === -1) {
        this.$message.warning(this.$t('CargoMsg.Cargo_CPIOOPRVCTBM'))
        this.closeLoading()
        return
      }
      if (actualAmount && !actualAmount.clearHistory) {
        await actualAmountApi.getClearHistory({ actualAmountUuid: actualAmount.uuid }).then(resp => {
          actualAmount.clearHistory = resp.data
          this.loadClearHistorResultHandler()
        }).catch(() => {
          this.closeLoading()
        })
      } else {
        this.loadClearHistorResultHandler()
      }
    },
    loadClearHistorResultHandler() {
      const actualAmount = this.clickRow
      if (actualAmount.clearHistory && actualAmount.clearHistory.length > 0) {
        this.$message.warning(this.$t('CargoMsg.Cargo_WrittenOffItemsCanTBeModified'))
        this.closeLoading()
        return
      }
      this.closeLoading()
      this.actualDialog.params = lodash.cloneDeep(actualAmount)
      this.actualDialog.ar = actualAmount.ar ? 1 : 0
      this.actualDialog.visible = true
    },
    // 作废 按钮事件
    async invalidAmountHandler() {
      this.loading = getLoading()
      if (!this.clickRow) {
        this.$message.warning(this.$t('CargoMsg.Cargo_NoDataSelected'))
        this.closeLoading()
        return
      }
      const actualAmount = this.clickRow
      if (actualAmount.approvedState !== ClearingConstants.ACT_AMOUNT_APPROVE_NONE.code) {
        this.$message.warning(this.$t('CargoMsg.Cargo_CPIOOPRCCTBV'))
        this.closeLoading()
        return
      }
      if (actualAmount && !actualAmount.clearHistory) {
        await actualAmountApi.getClearHistory({ actualAmountUuid: actualAmount.uuid }).then(resp => {
          actualAmount.clearHistory = resp.data
          this.loadClearHistorResult2Handler()
        }).catch(() => {
          this.closeLoading()
        })
      } else {
        this.loadClearHistorResult2Handler()
      }
    },
    loadClearHistorResult2Handler() {
      const actualAmount = this.clickRow
      if (actualAmount.clearHistory && actualAmount.clearHistory.length > 0) {
        this.$message.warning(this.$t('CargoMsg.Cargo_CPIOOPRWOCTBV'))
        this.closeLoading()
        return
      }
      writeoffApi.checkExportedToVoucher({ actualAmountUuid: actualAmount.uuid }).then(resp => {
        this.checkExportedToVoucherResultHandler(resp)
      }).catch(() => { this.closeLoading() })
      // ActualAmount.checkExportedToVoucher(actualAmount.key, checkExportedToVoucherResultHandler, loadClearHistorFaultHandler)
    },
    // 检查导出到凭证
    async checkExportedToVoucherResultHandler(event) {
      const exist = event.data
      if (exist) {
        this.$message.warning(this.$t('CargoMsg.Cargo_FVOCPIOOPRECTBV'))
        this.closeLoading()
        return
      }
      this.closeLoading()
      await this.$confirm(this.$t('CargoMsg.Cargo_SureToVoid'), this.$t('CargoMsg.Cargo_ConfirmR'), {
        confirmButtonText: this.$t('CargoMsg.Cargo_Confirm'),
        cancelButtonText: this.$t('CargoMsg.Cargo_Cancel'),
        showClose: false,
        closeOnClickModal: false,
        closeOnPressEscape: false,
        type: 'warning'
      })
      this.loading = getLoading()
      const actualAmount = this.clickRow
      actualAmount.state = -1
      actualAmount.branchId = this.$store.getters.currentOfficeId
      await actualAmountApi.saveActualAmount(actualAmount).then(resp => {
        this.$message.success(this.$t('CargoMsg.Cargo_VoidedSuccessfully'))
        // CARGO-11491，作废会提示系统忙数据被其他人修改
        this.refreshData()
      }).catch(() => {}).finally(() => {
        this.closeLoading()
      })
    },
    // 修改核销状态按钮事件
    modifyMatchStatusHandler() {
      const selections = this.$refs.writeOffSearch.getSelections()
      if (!selections || selections.length === 0) {
        this.$message.warning(this.$t('WriteOff.selectAtLeastOne'))
        return
      }
      this.modifyMatchStatusDialog.selectedRows = selections
      this.modifyMatchStatusDialog.visible = true
    },
    // 查看销账明细 按钮事件
    showWriteoffDetailHandler() {
      const actualAmount = this.clickRow
      this.chargeWriteOffDetailDialog.actualAmountUuid = actualAmount.uuid
      this.chargeWriteOffDetailDialog.isBill = false
      this.chargeWriteOffDetailDialog.isAr = true
      this.chargeWriteOffDetailDialog.isSetoff = false
      this.chargeWriteOffDetailDialog.totalGroupType = actualAmount.ar ? 'ar' : 'ap'
      this.chargeWriteOffDetailDialog.visible = true
    },
    queryResultCallBack(data) {
      this.rowData = data
      this.clickRow = null
    },
    closeLoading() {
      if (this.loading) {
        this.loading.close()
      }
    },
    beforeUpload(file) {
      const fileType = file.name.substring(file.name.lastIndexOf('.') + 1)
      const extension = fileType === 'xls'
      const extension2 = fileType === 'xlsx'
      if (!extension && !extension2) {
        this.$message.warning(this.$t('SeaExport.FileOnlyXlsXlsx'))
      }
      this.loading = getLoading()
      return extension || extension2
    },
    uploadSuccess(response, file, fileList) {
      this.loading.close()
      if (response && response.data) {
        this.$message.success(this.$t('SeaExport.ImportSuccess'))
      } else {
        if (response.errors && response.errors.length > 0) {
          this.$message.error(response.errors[0].message)
        } else {
          this.$message.error(response.message)
        }
      }
    },
    handleError(error) {
      const errorData = JSON.parse(error.message)
      this.$message.error({ 'message': errorData.message, 'duration': 15000 })
      this.loading.close()
    },
    // 导出公共
    exportHandle() {
      switch (this.exportCommand) {
        case this.$t('CargoMsg.Cargo_Import'):
          this.$refs.batchImport.submit()
          break
        case this.$t('SeaExport.TemplateDownload'):
          ExportUtils.downloadTemplateFile('BatchImportBankTransaction.xlsx', 'actualAmount')
          break
      }
    }
  }
}
</script>

<style scoped>
</style>
